import { GraphQLClient } from 'graphql-request';
import { Context, Events } from '../../machines/Admin/ApplicationReviewMachine';
import { RemoveBoardBlockDocument } from '../../graphql/operations';
import { adminApplicationFragmentSchema } from '../../schemas/admin/adminApplicationFragmentSchema';

type Event = Extract<Events, { type: 'REMOVE_BOARD_BLOCK' }>;

export const createRemoveBoardBlockPromise =
  (client: GraphQLClient) =>
  async ({ applicationId }: Context, { accountId }: Event) => {
    const request = await client.request(RemoveBoardBlockDocument, {
      accountId,
      applicationId,
    });

    const application = request.result?.query?.application;

    return adminApplicationFragmentSchema.parseAsync(application);
  };

export type CreateRemoveBoardBlockPromise = ReturnType<
  typeof createRemoveBoardBlockPromise
>;
export type CreateRemoveBoardBlockPromiseResult = Awaited<
  ReturnType<CreateRemoveBoardBlockPromise>
>;
